import {
  useCallback,
  useEffect,
  // useLayoutEffect,
  // useRef,
  // useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Player, PlayerActions, PlayerOverlay } from "src/components/player";
import { ProgramAvailablity, ProgramType } from "src/enums";
import { ProgramDetail, ProgramViewAction, UserSession } from "src/store";
import logo from "src/assets/static/img/main/anten-logo-new-light.svg";
import { StringService } from "src/services";
import { Container } from "react-bootstrap";
// import IframeResizer from "iframe-resizer-react";
// import axios from "axios";
// import { PlayerVPNOverlay } from "src/components/player/player.overlay.vpn";

// type VPNStatusType = {
//   isValid: boolean;
//   title: string;
//   message: string;
// };

export const ProgramViewHeader: React.FC<{
  programType?: ProgramType;
  packageId?: number;
}> = ({ programType }) => {
  //#region depenencies

  const dispatch = useDispatch();
  const { replace } = useHistory();
  const programInfo: ProgramDetail = useSelector(
    (state: any) => state.ProgramViewState
  );
  const user: UserSession = useSelector((state: any) => state.UserState);
  //#endregion

  //#region properties

  const { id, slug }: any = useParams();

  //#endregion

  //#region mehtods

  const fetchData = useCallback(() => {
    if (programInfo.loading) return;

    dispatch(ProgramViewAction.requestProgramInfo(id, programType));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, programInfo.loading, user.loggedIn]);

  //#endregion

  //#region effects

  useEffect(() => {
    fetchData();

    return () => {
      dispatch(ProgramViewAction.clearProgramInfo());
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, user.loggedIn]);

  useEffect(() => {
    if (programInfo.info) {
      const sanitized = StringService.sanitize(programInfo.info.title);
      if (sanitized !== slug && +id === programInfo.info.id)
        replace(
          `/${
            programType === ProgramType.ArchiveVideo ? "archive" : "program"
          }/${id}/${sanitized}`
        );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, programInfo.info]);

  //#endregion

  // const playerRef = useRef(null);

  // const [dimensions, setDimensions] = useState({
  //   width: 758,
  // });

  // useLayoutEffect(() => {
  //   function handleResize() {
  //     setDimensions({
  //       // @ts-ignore
  //       width: playerRef?.current?.offsetWidth || 758,
  //     });
  //   }
  //   window.addEventListener("resize", handleResize);

  //   if (programInfo.info?.iframe) handleResize();

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [programInfo.info?.iframe]);

  // const [isIframe, setIsIframe] = useState(false);

  // const getIframeStatus = useCallback(async () => {
  //   try {
  //     const { data } = await axios.post(
  //       `${process.env.REACT_APP_REPORT_URL}programs/${id}/reportPlaybackIframe`
  //     );

  //     setIsIframe(!!data.result);
  //   } catch (error) {
  //     setIsIframe(false);
  //   }
  // }, [id]);

  // useEffect(() => {
  //   if (!isIframe) {
  //     getIframeStatus();
  //   }
  //   const interval = setInterval(() => {
  //     getIframeStatus();
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [getIframeStatus, isIframe]);

  // useEffect(() => {
  //   if (!programInfo.info?.startAt) return;
  //   if (new Date(programInfo.info?.startAt).getTime() < Date.now()) return;

  //   if (programInfo.info?.startAt) {
  //     const timeout = setTimeout(() => {
  //       window.location.reload();
  //     }, new Date(programInfo.info?.startAt).getTime() - Date.now());

  //     return () => {
  //       clearTimeout(timeout);
  //     };
  //   }
  // }, [programInfo.info?.startAt]);

  // const [VPNStatus, setVPNStatus] = useState<VPNStatusType>({
  //   isValid: true,
  //   title: "",
  //   message: "",
  // });

  // const [checkAgainLoading, setCheckAgainLoading] = useState(false);

  // const getVpn = useCallback(async () => {
  //   try {
  //     setCheckAgainLoading(true);
  //     const { data: vpnData } = await axios.get(
  //       `${process.env.REACT_APP_API_URL}ip-detector`
  //     );
  //     setVPNStatus(vpnData);
  //     setCheckAgainLoading(false);
  //   } catch (error) {
  //     setCheckAgainLoading(false);
  //     console.log("vpn", error);
  //   }
  // }, []);

  // useEffect(() => {
  //   getVpn();
  // }, [getVpn]);

  // console.log(
  //   programInfo.info?.iframe &&
  //     new Date(programInfo.info?.startAt).getTime() < Date.now() &&
  //     isIframe,
  //   VPNStatus.isValid
  // );

  //   const isSmartTV = () => {
  //     const userAgent = navigator.userAgent || navigator.vendor;
  //     if (
  //       userAgent.match(/googletv/i) ||
  //       userAgent.match(/viera/i) ||
  //       userAgent.match(/smarttv/i) ||
  //       userAgent.match(/internet.tv/i) ||
  //       userAgent.match(/netcast/i) ||
  //       userAgent.match(/nettv/i) ||
  //       userAgent.match(/appletv/i) ||
  //       userAgent.match(/boxee/i) ||
  //       userAgent.match(/kylo/i) ||
  //       userAgent.match(/roku/i) ||
  //       userAgent.match(/dlnadoc/i) ||
  //       userAgent.match(/roku/i) ||
  //       userAgent.match(/pov_tv/i) ||
  //       userAgent.match(/hbbtv/i) ||
  //       userAgent.match(/ce-html/i) ||
  //       userAgent.match(/webOS/i) ||
  //       userAgent.match(/Tizen/i) ||
  //       userAgent.match(/tizen/i) ||
  //       userAgent.match(/lg browser/i) ||
  //       userAgent.match(/viera/i) ||
  //       userAgent.match(/Android TV/i) ||
  //       userAgent.match(/opera tv/i) ||
  //       userAgent.match(/opera tv store/i) ||
  //       userAgent.match(/opera mini/i) ||
  //       userAgent.match(/opera mobi/i) ||
  //       userAgent.match(/opera tablet/i) ||
  //       userAgent.match(/opera mini/i) ||
  //       userAgent.match(/opera mobi/i)
  //     ) {
  //       return true;
  //     }
  //     return false;
  //   };
  // console.log('tv', isSmartTV())
  return (
    <Container fluid style={{ height: "100%" }}>
      <div className="media-player-area">
        {programInfo.loading && (
          <div className="shimmer absolute">
            <img src={logo} alt="" />
          </div>
        )}
        {programInfo.info && (
          <div className="vjs-player">
            <div
              style={{
                backgroundImage: `url(${programInfo.info?.cover})`,
              }}
              className="no-video-cover"
            />
          </div>
        )}
        {programInfo.availability !== ProgramAvailablity.Available && (
          <PlayerOverlay
            stream={programInfo.currentStream}
            qualityConfig={programInfo.info?.qualityConfig}
            btnLoading={programInfo.ipChecking}
            programId={+id}
            packageId={programInfo.info?.packageId}
            programType={programType}
            streamId={programInfo.currentStream?.id || 0}
            otherSession={programInfo.killSessionId}
            {...programInfo.message}
            availability={
              programInfo.availability || ProgramAvailablity.Available
            }
          />
        )}
        {programInfo.availability === ProgramAvailablity.Available &&
          programInfo.player && (
            <Player
              programTitle={programInfo.info?.title}
              qualityConfig={programInfo.info?.qualityConfig}
              packageId={programInfo.info?.packageId}
              programType={programType}
              {...programInfo.player}
              poster={programInfo.info?.cover}
              streams={programInfo.info?.streams}
              currentStream={programInfo.currentStream}
            />
          )}
      </div>
    </Container>
  );
};
